import type { FaireProductEntity } from "../../entity_types/product";

export const p_fyejmrsyhx: FaireProductEntity = {
  token: "p_fyejmrsyhx",
  type: "product",
  name: "NINI - Chic Mule, Knot Detail, Gold Bamboo Heel",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/08aaadf793ed66d4ce20ea62feecc0b6bdb81ef22e3cd17de9a5dbf768ccdb66.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d965d264845d05eca4a3f8458bb1eeb056ff5043c8b9ff91b56a0ef72997d128.jpeg",
    "https://cdn.faire.com/fastly/b52c95db078936689c04b205d318f026afc20c10013b094d4e954817404cd8ab.jpeg",
    "https://cdn.faire.com/fastly/38ce1f1a995ca7cc4d233620a7ee1b3ba5e1e02423d7ff209b1c98ff5ae3732a.jpeg",
    "https://cdn.faire.com/fastly/1c93bdf8efc921faaea93d0175ed44231afe1fd8a7a839766aa509487caeacc8.jpeg",
  ],
  priceDollars: 13.75,
  description:
    "A timeless slide with a playful twist, this kitten heel sandal features a smooth upper accented with delicate knotted details for an elevated finish. The easy slip-on silhouette and low heel make it the perfect choice for everyday wear or dressed-up occasions. Available in blush pink, pistachio green, black, and chocolate brown.\n\nOOTD\nPair them with tailored shorts and a linen button-down for an effortless daytime look, or style them with a satin midi skirt and a fitted tank for dinner plans. Add a woven bag and dainty gold jewelry for an understated yet polished outfit.",
  tags: [],
  msrpDollars: 27.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:08.736Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
